import React from 'react';
import Highcharts from 'highcharts';
import styled, { keyframes, css } from 'styled-components';
import { commonSettings } from '../charts.constants';
import { Chart } from '../Chart';
import { Wrapper } from '../../Wrapper/Wrapper';
import { theme as baseTheme } from '../../../../theme/theme';

const loadingChartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'pie',
    margin: [0, 0, 0, 0],
    spacingTop: 0,
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    style: {
      fontFamily: baseTheme.fontFamily,
    },
  },

  title: {
    text: '54%',
    useHTML: true,
    floating: false,
    verticalAlign: 'middle',
    align: 'center',
    margin: 0,
    style: {
      fontSize: '0',
    },
  },

  tooltip: {
    enabled: false,
  },

  series: [
    {
      type: 'pie',
      data: [
        { name: 'Success', y: 85, color: baseTheme.colors.neutral['400'] },
        { name: 'Failure', y: 15, color: baseTheme.colors.neutral['200'] },
      ],
    },
  ],

  plotOptions: {
    pie: {
      slicedOffset: 0,
      enableMouseTracking: false,
      innerSize: '84%',
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
};

const dash = keyframes`
  to {
    opacity: 0.4;
  }
`;

export const StyledChart = styled(Wrapper)<{ hasTitle: boolean }>(
  ({ hasTitle, theme }) => ({
    position: 'relative',

    opacity: 1,
    width: '100%',
    height: '100%',

    '& .highcharts-title': hasTitle
      ? {
          width: ' 33px',
          height: ' 20px',
          background: theme.colors.neutral[200],
          borderRadius: '6px',
        }
      : {},
  }),
  css`
    animation: ${dash} 1s ease alternate infinite;
  `,
);

interface Props {
  hasTitle?: boolean;
  innerSize?: string;
}

export const PieChartLoading: React.FC<Props> = ({ hasTitle = false, innerSize = '84%' }) => {
  const settings = {
    ...loadingChartSettings,
    plotOptions: {
      series: {
        animation: false,
      },
      ...loadingChartSettings.plotOptions,
      pie: {
        ...loadingChartSettings.plotOptions?.pie,
        innerSize,
      },
    },
  };

  return (
    <StyledChart hasTitle={hasTitle}>
      <Chart options={settings} />
    </StyledChart>
  );
};
